import { Button, Typography } from "@suraasa/placebo-ui"
import AsyncBuilder from "components/AsyncBuilder"
import PageContainer from "components/PageContainer"
import { useSuraasaPlusContext } from "features/SuraasaPlus/context"

const SubscriptionExpiredBanner = () => {
  const {
    isExpired,
    isCancelled,
    initiateSuraasaPlusPurchaseFlow,
    subscriptionDetails,
  } = useSuraasaPlusContext()

  // Free trial subscriptions have their own "trial ended" messaging
  // (FreeTrialBanner/FreeTrialCard) — this banner is only for paid subscriptions.
  if (
    (isExpired || isCancelled) &&
    !subscriptionDetails?.subscription.isFreeClaim
  ) {
    return (
      <div className="bg-critical-500 py-2">
        <PageContainer>
          <div className="flex flex-row items-start gap-1.5 sm:items-center">
            <div className="flex size-2.5 shrink-0 items-center justify-center rounded-full bg-critical-800">
              <div className="h-0.25 w-1/2 bg-white" />
            </div>
            <div className="flex flex-col justify-between sm:w-full sm:flex-row sm:items-center">
              {isExpired && (
                <Typography variant="title4" className="mb-0.25 text-white">
                  Your Suraasa Plus subscription has expired.{" "}
                  <span className="text-body text-surface/70">
                    <br className="block sm:hidden" />
                    Renew now to regain access to all your benefits.
                  </span>
                </Typography>
              )}
              {isCancelled && (
                <Typography variant="title4" className="mb-0.25 text-white">
                  Your Suraasa Plus subscription has been cancelled.{" "}
                  <span className="text-body text-surface/70">
                    <br className="block sm:hidden" />
                    Renew now to continue accessing all benefits.
                  </span>
                </Typography>
              )}
              <AsyncBuilder
                handler={() => initiateSuraasaPlusPurchaseFlow(true)}
                render={props => (
                  <Button
                    color="black"
                    className="mt-2.5 w-fit shrink-0 p-1 sm:mt-0"
                    onClick={props.onClick}
                    loading={props.loading}
                  >
                    Renew Now
                  </Button>
                )}
              />
            </div>
          </div>
        </PageContainer>
      </div>
    )
  }
}

export default SubscriptionExpiredBanner
